import moment from 'moment-timezone';
import React from 'react';
import { AutosaveIndicator, AutosaveStates } from '../AutosaveIndicator';
import { DraftPublishedChip, DraftPublishedChipStatus } from './DraftPublishedChip';
import styles from './HeaderWithControls.module.scss';

const Title: React.FC<{
    label: string;
}> = props => {
    return (
        <div className={styles.header}>
            <div className={styles.display}>{props.label}</div>
        </div>
    );
};

const InfoLine: React.FC<{
    /**
     * Expected to be a Date Time Iso
     */
    updatedOn: string;
    updatedBy: string;
    autoSaveIndicator?: {
        status: AutosaveStates;
        retry?(): Promise<void>;
    };
    draftPublishedChipStatus: DraftPublishedChipStatus;
}> = props => {
    const updatedOn = moment(props.updatedOn).fromNow();

    return (
        <div className={styles.infoContainer}>
            <DraftPublishedChip status={props.draftPublishedChipStatus} />
            <div className={styles.info}>{` · Edited by ${props.updatedBy} · ${updatedOn}`}</div>
            {!!props.autoSaveIndicator && (
                <div className={styles.status}>
                    <AutosaveIndicator
                        retryFunction={props.autoSaveIndicator.retry}
                        saveState={props.autoSaveIndicator.status}
                    />
                </div>
            )}
        </div>
    );
};

export const HeaderWithControls: React.FC<{
    title: string;
    /**
     * Expected to be a Date Time Iso
     */
    updatedOn: string;
    updatedBy: string;
    buttons: React.ReactNode;
    autoSaveIndicator?: {
        status: AutosaveStates;
        retry?(): Promise<void>;
    };
    draftPublishedChipStatus: DraftPublishedChipStatus;
}> = props => {
    return (
        <div className={styles.stickyHeader}>
            <div className={styles.headerContainer}>
                <Title label={props.title} />
                <div className={styles.controls}>{props.buttons}</div>
            </div>
            <InfoLine
                updatedBy={props.updatedBy}
                updatedOn={props.updatedOn}
                draftPublishedChipStatus={props.draftPublishedChipStatus}
                autoSaveIndicator={props.autoSaveIndicator}
            />
        </div>
    );
};
